"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockGetBillStatusResponseDepositNotPaidFSLC = exports.mockGetBillStatusResponseDepositFunded = exports.mockGetBillStatusResponseDepositNotPaid = exports.mockGetAccountRelinkingResponse = exports.mockGetAccountOnboardingResponse = exports.mockGetAccountResponse = exports.mockFlexAnywhereBillerId = exports.mockRescheduleOptions = exports.mockBillAmountPayNow = exports.mockBillAmount = exports.mockDdaDetails = exports.ddaAddressInfo = exports.ddaNameInfo = exports.mockRelinkEligibilityTrue = exports.mockRelinkEligibilityFalse = exports.mockDeleteAccountEligibilityTrue = exports.mockDeleteAccountEligibilityFalse = exports.mockOptedOutRentReporting = exports.mockOptedInRentReporting = exports.mockCancelBillIneligible = exports.mockUpdatedRentAmountSLCScheduleEmbedEpisodic = exports.mockUpdatedRentAmountScheduleEmbedEpisodic = exports.mockUpdatedRentAmountSLCSchedule = exports.mockUpdatedRentAmountScheduleEpisodic = exports.mockUpdatedRentAmountSchedule = exports.mockPayNowEligible = exports.mockCancelBillEligible = exports.mockWalletIneligibleUser = exports.mockWalletEligibleUser = exports.mockCreditCard = exports.mockDebitCardNotStripeConnected = exports.stripeConfirmCard = exports.setupCardDetails = exports.mockDebitCard = exports.creditCard = exports.debitCardNotStripeConnect = exports.debitCard = exports.mockWalletBalanceZeroBalanceFirstPayment = exports.mockWalletBalanceFullyFundedFirstPayment = exports.mockWalletBalance = exports.mockTransactionDetailsPropertyFeePassthrough = exports.mockFundsActivity = exports.mockTransactionDetailsActiveRollover = exports.mockTransactionDetails = exports.mockTransactionHistory = exports.bpEndDate = exports.bpStartDate = exports.firstOfNextMonth = exports.fifteenthOfMonth = exports.firstOfMonth = void 0;
exports.mockGetCutoffDates = exports.mockGetRentAmountSurveyOptions = exports.mockGetRentBillDetails = exports.mockRescheduleDPOptions = exports.mockBillPayNowEmbedEligibilityErrorUnknown = exports.mockBillPayNowEmbedEligibilityErrorInvalidBalance = exports.mockBillPayNowEmbedEligibilityErrorInvalidProduct = exports.mockBillPayNowEmbedEligibilityErrorRentPaid = exports.mockBillPayNowEmbedEligibilityErrorRentPaymentInProgress = exports.mockBillPayNowEmbedEligibilityErrorAutopayOn = exports.mockBillPayNowEmbedEligibilityErrorBpWindow = exports.mockBillPayNowEmbedEligibilitySuccess = exports.mockGetBillStatusResponseEpisodicReadyToPay = exports.mockGetBillStatusResponseRelink = exports.mockGetBillStatusCreditBuilderResponseFullyPaid = exports.mockGetBillStatusResponseFullyPaid = exports.mockGetPaymentStatusCreditBuilderMonthTwoRepaymentFailed = exports.mockGetPaymentStatusCreditBuilderMonthTwo = exports.mockGetPaymentStatusCreditBuilder = exports.mockGetPaymentStatusSecondPayment = exports.mockGetPaymentStatusInsufficientFunds = exports.mockGetPaymentStatusSecondPaymentFailed = exports.mockGetPaymentStatusNotCovered = exports.mockGetPaymentStatusCovered = exports.mockGetPaymentStatusFirstPaymentPaid = exports.mockGetPaymentStatusFirstPaymentFunded = exports.mockGetPaymentStatusDepositPaid = exports.mockGetPaymentStatusScheduledNoPrePay = exports.mockGetPaymentStatusReschedule = exports.mockGetPaymentStatusScheduled = exports.mockGetPaymentStatus = exports.mockGetBillStatusResponseRentPaidUpcomingPayment = exports.mockGetBillStatusResponsePayingRent = void 0;
var domain_1 = require("@genoa/domain");
var luxon_1 = require("luxon");
exports.firstOfMonth = luxon_1.DateTime.utc().set({ day: 1, hour: 0, minute: 0, second: 0, millisecond: 0 }).toISODate();
exports.fifteenthOfMonth = luxon_1.DateTime.utc()
    .set({ day: 15, hour: 0, minute: 0, second: 0, millisecond: 0 })
    .toISODate();
exports.firstOfNextMonth = luxon_1.DateTime.utc()
    .plus({ months: 1 })
    .set({ day: 1, hour: 0, minute: 0, second: 0, millisecond: 0 })
    .toISODate();
exports.bpStartDate = luxon_1.DateTime.utc().endOf('month').toISODate();
exports.bpEndDate = luxon_1.DateTime.utc().set({ day: 5, hour: 0, minute: 0, second: 0, millisecond: 0 }).toISODate();
exports.mockTransactionHistory = [
    {
        id: 'transaction-1',
        amount: 60600,
        date: '2023-07-14T22:00:00.000Z',
        display_name: 'Refund of your 1st payment',
        is_settled: true,
        transaction_type: domain_1.TransactionType.REFUND,
    },
    {
        id: 'transaction-2',
        amount: 60600,
        date: '2023-06-30T22:00:00.000Z',
        display_name: '1st payment',
        transaction_type: domain_1.TransactionType.RENT_PAYMENT,
        is_settled: true,
    },
    {
        id: 'transaction-3',
        amount: 1499,
        date: '2023-06-14T22:00:00.000Z',
        display_name: 'Membership fee',
        is_settled: true,
        transaction_type: domain_1.TransactionType.MEMBERSHIP_FEE,
    },
    {
        id: 'transaction-4',
        amount: 60600,
        date: '2023-06-12T22:00:00.000Z',
        display_name: '2nd payment',
        transaction_type: domain_1.TransactionType.RENT_PAYMENT,
        is_settled: false,
    },
    {
        id: 'transaction-5',
        amount: 120000,
        date: '2023-06-01T22:00:00.000Z',
        transaction_type: domain_1.TransactionType.DOWN_PAYMENT,
        is_settled: true,
        display_name: 'Flex paid your rent',
    },
    {
        id: 'transaction-6',
        amount: 120000,
        date: '2023-05-30T22:00:00.000Z',
        display_name: '1st payment',
        transaction_type: domain_1.TransactionType.RENT_PAYMENT,
        is_settled: true,
    },
    {
        id: 'transaction-7',
        amount: 1499,
        date: '2023-05-14T22:00:00.000Z',
        display_name: 'Membership fee',
        is_settled: true,
        transaction_type: domain_1.TransactionType.MEMBERSHIP_FEE,
    },
    /// 2nd batch
    {
        id: 'transaction-8',
        amount: 60600,
        date: '2023-04-30T22:00:00.000Z',
        display_name: '1st payment',
        transaction_type: domain_1.TransactionType.RENT_PAYMENT,
        is_settled: true,
    },
    {
        id: 'transaction-9',
        amount: 1499,
        date: '2023-04-14T22:00:00.000Z',
        display_name: 'Membership fee',
        is_settled: true,
        transaction_type: domain_1.TransactionType.MEMBERSHIP_FEE,
    },
    {
        id: 'transaction-10',
        amount: 60600,
        date: '2023-04-12T22:00:00.000Z',
        display_name: '2nd payment',
        transaction_type: domain_1.TransactionType.RENT_PAYMENT,
        is_settled: true,
    },
    {
        id: 'transaction-11',
        amount: 120000,
        date: '2023-04-01T22:00:00.000Z',
        transaction_type: domain_1.TransactionType.DOWN_PAYMENT,
        display_name: 'Flex paid your rent',
        is_settled: true,
    },
    {
        id: 'transaction-12',
        amount: 120000,
        date: '2023-03-30T22:00:00.000Z',
        display_name: '1st payment',
        transaction_type: domain_1.TransactionType.RENT_PAYMENT,
        is_settled: true,
    },
];
exports.mockTransactionDetails = {
    user_payment_public_id: '12345',
    type: domain_1.TransactionType.RENT_PAYMENT,
    status: domain_1.TransactionStatus.PAID,
    date: '2023-10-01',
    title: 'Flex paid your rent',
    heading_1: 'The Royal Arms Apt',
    heading_1_label: '1234 Drive, Ny New York 10001',
    total_cents: 120000,
    outstanding_cents: 0,
    next_auth_attempt: '',
    can_pay_now: false,
    can_pre_fund: false,
    activity: [
        {
            amount_cents: 60000,
            date: '2023-10-01',
            display_title: 'Flex credit line',
            display_subtext: '',
            type: domain_1.TransactionType.CHARGE,
            category: domain_1.TransactionCategory.FLEX_CREDIT_LINE,
        },
        {
            amount_cents: 60000,
            date: '2023-10-01',
            display_title: '1st payment',
            display_subtext: '',
            type: domain_1.TransactionType.CHARGE,
            category: domain_1.TransactionCategory.PAYMENT,
        },
    ],
};
exports.mockTransactionDetailsActiveRollover = {
    user_payment_public_id: '12345',
    type: domain_1.TransactionType.PAYMENT,
    status: domain_1.TransactionStatus.FAILED,
    date: '2024-06-01',
    title: '2nd payment',
    heading_1: '',
    heading_1_label: '',
    total_cents: 60600,
    outstanding_cents: 60600,
    next_auth_attempt: '2024-06-01',
    can_pay_now: true,
    can_pre_fund: false,
    activity: [
        {
            amount_cents: 60000,
            date: '2024-06-01',
            display_title: '1st payment',
            display_subtext: '',
            type: domain_1.TransactionType.CHARGE,
            category: domain_1.TransactionCategory.PAYMENT,
        },
    ],
};
exports.mockFundsActivity = [
    {
        amount: 60600,
        date: '2023-07-14T22:00:00.000Z',
        type: 'ADDED',
        meta: 'from debit card x2222',
        dispute: null,
    },
    {
        amount: 60600,
        date: '2023-06-30T22:00:00.000Z',
        type: 'WITHDRAWN',
        meta: 'to debit card x1234',
        dispute: null,
    },
    {
        amount: 1499,
        date: '2023-06-14T22:00:00.000Z',
        type: 'APPLIED',
        meta: 'to 2nd payment',
        dispute: null,
    },
    {
        amount: 60600,
        date: '2023-06-12T22:00:00.000Z',
        type: 'ADDED',
        meta: 'from debit card x1234',
        dispute: null,
    },
    {
        amount: 60600,
        date: '2023-06-01T22:00:00.000Z',
        type: 'ADDED',
        meta: 'from debit card x1234',
        dispute: null,
    },
    {
        amount: 60600,
        date: '2023-05-30T22:00:00.000Z',
        type: 'WITHDRAWN',
        meta: 'to debit card x1234',
        dispute: null,
    },
    {
        amount: 1499,
        date: '2023-05-14T22:00:00.000Z',
        type: 'APPLIED',
        meta: 'to 2nd payment',
        dispute: null,
    },
    {
        amount: 60600,
        date: '2023-04-30T22:00:00.000Z',
        type: 'ADDED',
        meta: 'from debit card x1234',
        dispute: null,
    },
    {
        amount: 60600,
        date: '2023-04-14T22:00:00.000Z',
        type: 'WITHDRAWN',
        meta: 'to debit card x1234',
        dispute: null,
    },
    {
        amount: 1499,
        date: '2023-04-12T22:00:00.000Z',
        type: 'APPLIED',
        meta: 'to 2nd payment',
        dispute: null,
    },
    {
        amount: 60600,
        date: '2023-04-01T22:00:00.000Z',
        type: 'ADDED',
        meta: 'from debit card x1234',
        dispute: null,
    },
    {
        amount: 60600,
        date: '2023-03-30T22:00:00.000Z',
        type: 'ADDED',
        meta: 'from debit card x1234',
        dispute: null,
    },
];
exports.mockTransactionDetailsPropertyFeePassthrough = {
    user_payment_public_id: '12345',
    type: domain_1.TransactionType.PAYMENT,
    status: domain_1.TransactionStatus.SCHEDULED,
    date: '2024-06-01',
    title: '2nd payment',
    heading_1: '',
    heading_1_label: '',
    total_cents: 60900,
    outstanding_cents: 60900,
    next_auth_attempt: '2024-06-01',
    can_pay_now: false,
    can_pre_fund: false,
    activity: [
        {
            amount_cents: 60000,
            date: '2024-06-01',
            display_title: '1st payment',
            display_subtext: '',
            type: domain_1.TransactionType.CHARGE,
            category: domain_1.TransactionCategory.PAYMENT,
        },
        {
            amount_cents: 600,
            date: '2024-06-01',
            display_title: 'Bill payment fee (1% of rent)',
            display_subtext: '',
            type: domain_1.TransactionType.CHARGE,
            category: domain_1.TransactionCategory.BILL_PAYMENT_FEE,
        },
        {
            amount_cents: 300,
            date: '2024-06-01',
            display_title: 'Property passthrough fee',
            display_subtext: '',
            type: domain_1.TransactionType.CHARGE,
            category: domain_1.TransactionCategory.PROPERTY_PASSTHROUGH_FEE,
        },
    ],
};
exports.mockWalletBalance = {
    available: 5000,
    current: 15000,
};
exports.mockWalletBalanceFullyFundedFirstPayment = {
    available: 101000,
    current: 101000,
};
exports.mockWalletBalanceZeroBalanceFirstPayment = {
    available: 0,
    current: 0,
};
exports.debitCard = {
    stripe_customer_id: '12345-asdfg-23456-sdfgh-1z2x3',
    brand: 'Visa',
    card_mask: '5556',
    is_active: false,
    stripe_payment_method_id: 'mklpo-09876-njiuh-98765-vgytf',
    card_type: 'debit',
    fingerprint: 'AW34FGTY78HGHF',
    issuer: 'VISA',
    is_stripe_connect_setup: true,
    address_line_one: '123 Easy Street',
    address_city: 'Anytown',
    address_state: 'GA',
    address_zipcode: '11111',
};
exports.debitCardNotStripeConnect = {
    stripe_customer_id: '12345-asdfg-23456-sdfgh-1z2x3',
    brand: 'Visa',
    card_mask: '5556',
    is_active: false,
    stripe_payment_method_id: 'mklpo-09876-njiuh-98765-vgytf',
    card_type: 'debit',
    fingerprint: 'AW34FGTY78HGHF',
    issuer: 'VISA',
    is_stripe_connect_setup: false,
};
exports.creditCard = {
    stripe_customer_id: '12345-asdfg-23456-sdfgh-1z2x3',
    brand: 'Visa',
    card_mask: '4242',
    is_active: false,
    stripe_payment_method_id: 'mklpo-09876-njiuh-98765-vgytf',
    card_type: 'credit',
    fingerprint: 'AW34FGTY78HGHF',
    issuer: 'VISA',
    is_stripe_connect_setup: false,
};
exports.mockDebitCard = {
    default: exports.debitCard,
};
exports.setupCardDetails = {
    stripe_client_secret: 'seti_HM4TGtkSXdIdTdpeDJmVFJHO_secret_NXDICkPqPeiBTAFqWmkbff09lRmSVXe',
    current_card_match: true,
};
exports.stripeConfirmCard = {
    stripe_client_secret: 'seti_HM4TGtkSXdIdTdpeDJmVFJHO_secret_TlhESUNrUHFQZWlCVEFGcVdta2JmZYQ',
    current_card_match: true,
};
exports.mockDebitCardNotStripeConnected = {
    default: exports.debitCardNotStripeConnect,
};
exports.mockCreditCard = {
    default: exports.creditCard,
};
exports.mockWalletEligibleUser = {
    eligible: true,
};
exports.mockWalletIneligibleUser = {
    eligible: false,
    reason: 'TOS',
};
exports.mockCancelBillEligible = {
    eligible: true,
};
exports.mockPayNowEligible = {
    eligible: true,
};
exports.mockUpdatedRentAmountSchedule = [
    {
        payment_status: domain_1.PaymentStatus.SCHEDULED,
        payment_category: domain_1.EstimatedPaymentCategory.DOWN_PAYMENT,
        user_payment_public_id: '10001-10001-10001-10000',
        amount: 15000,
        bill_date: '2022-10-01',
        processing_fee_percent: 0.01,
    },
    {
        payment_status: domain_1.PaymentStatus.SCHEDULED,
        payment_category: domain_1.PaymentCategory.MEMBERSHIP_FEE,
        user_payment_public_id: '10001-10001-10001-10000',
        amount: 1499,
        bill_date: '2022-10-15',
        processing_fee_percent: null,
    },
    {
        payment_status: domain_1.PaymentStatus.SCHEDULED,
        payment_category: domain_1.EstimatedPaymentCategory.REPAYMENT,
        user_payment_public_id: '10001-10001-10001-10000',
        amount: 15000,
        bill_date: '2022-10-15',
        processing_fee_percent: 0.01,
        property_passthrough_fee_amount: 300,
    },
];
exports.mockUpdatedRentAmountScheduleEpisodic = [
    {
        payment_status: domain_1.PaymentStatus.SCHEDULED,
        payment_category: domain_1.EstimatedPaymentCategory.DOWN_PAYMENT,
        user_payment_public_id: '10001-10001-10001-10000',
        amount: 50000,
        bill_date: '2022-10-01',
        processing_fee_percent: 0.01,
    },
    {
        payment_status: domain_1.PaymentStatus.SCHEDULED,
        payment_category: domain_1.PaymentCategory.MEMBERSHIP_FEE,
        user_payment_public_id: '10001-10001-10001-10000',
        amount: 1499,
        bill_date: '2022-10-15',
        processing_fee_percent: null,
    },
    {
        payment_status: domain_1.PaymentStatus.SCHEDULED,
        payment_category: domain_1.EstimatedPaymentCategory.REPAYMENT,
        user_payment_public_id: '10001-10001-10001-10000',
        amount: 50000,
        bill_date: '2022-10-15',
        processing_fee_percent: 0.01,
        property_passthrough_fee_amount: 300,
    },
];
exports.mockUpdatedRentAmountSLCSchedule = [
    {
        payment_status: domain_1.PaymentStatus.SCHEDULED,
        payment_category: domain_1.EstimatedPaymentCategory.DOWN_PAYMENT,
        user_payment_public_id: '10001-10001-10001-10000',
        amount: 65000,
        bill_date: '2022-10-01',
        processing_fee_percent: 0.0,
        base_amount: 65000,
    },
    {
        payment_status: domain_1.PaymentStatus.SCHEDULED,
        payment_category: domain_1.EstimatedPaymentCategory.REPAYMENT,
        user_payment_public_id: '10001-10001-10001-10000',
        amount: 66300,
        bill_date: '2022-10-15',
        processing_fee_percent: 2,
        processing_fee: 1300,
        base_amount: 65000,
    },
    {
        payment_status: domain_1.PaymentStatus.SCHEDULED,
        payment_category: domain_1.EstimatedPaymentCategory.REPAYMENT,
        user_payment_public_id: '10001-10001-10001-10000',
        amount: 66300,
        bill_date: '2022-10-27',
        processing_fee_percent: 2,
        processing_fee: 1300,
        base_amount: 65000,
    },
];
exports.mockUpdatedRentAmountScheduleEmbedEpisodic = [
    {
        payment_status: domain_1.PaymentStatus.SCHEDULED,
        payment_category: domain_1.EstimatedPaymentCategory.DOWN_PAYMENT,
        user_payment_public_id: '10001-10001-10001-10000',
        amount: 50000,
        bill_date: exports.firstOfMonth,
        processing_fee_percent: 0.01,
    },
    {
        payment_status: domain_1.PaymentStatus.SCHEDULED,
        payment_category: domain_1.PaymentCategory.MEMBERSHIP_FEE,
        user_payment_public_id: '10001-10001-10001-10000',
        amount: 1499,
        bill_date: exports.fifteenthOfMonth,
        processing_fee_percent: null,
    },
    {
        payment_status: domain_1.PaymentStatus.SCHEDULED,
        payment_category: domain_1.EstimatedPaymentCategory.REPAYMENT,
        user_payment_public_id: '10001-10001-10001-10000',
        amount: 50000,
        bill_date: exports.fifteenthOfMonth,
        processing_fee_percent: 0.01,
        property_passthrough_fee_amount: 300,
    },
];
exports.mockUpdatedRentAmountSLCScheduleEmbedEpisodic = [
    {
        payment_status: domain_1.PaymentStatus.SCHEDULED,
        payment_category: domain_1.EstimatedPaymentCategory.DOWN_PAYMENT,
        user_payment_public_id: '10001-10001-10001-10000',
        amount: 65000,
        bill_date: exports.firstOfMonth,
        processing_fee_percent: 0.0,
        base_amount: 65000,
    },
    {
        payment_status: domain_1.PaymentStatus.SCHEDULED,
        payment_category: domain_1.EstimatedPaymentCategory.REPAYMENT,
        user_payment_public_id: '10001-10001-10001-10000',
        amount: 66300,
        bill_date: exports.fifteenthOfMonth,
        processing_fee_percent: 2,
        processing_fee: 1300,
        base_amount: 65000,
    },
    {
        payment_status: domain_1.PaymentStatus.SCHEDULED,
        payment_category: domain_1.EstimatedPaymentCategory.REPAYMENT,
        user_payment_public_id: '10001-10001-10001-10000',
        amount: 66300,
        bill_date: exports.fifteenthOfMonth,
        processing_fee_percent: 2,
        processing_fee: 1300,
        base_amount: 65000,
    },
];
exports.mockCancelBillIneligible = {
    eligible: false,
};
exports.mockOptedInRentReporting = {
    opt_in_status: true,
};
exports.mockOptedOutRentReporting = {
    opt_in_status: false,
};
exports.mockDeleteAccountEligibilityFalse = {
    eligible: false,
    failures: [
        {
            message: 'You have paid a downpayment for your rent.',
        },
    ],
};
exports.mockDeleteAccountEligibilityTrue = {
    eligible: true,
    failures: [],
};
exports.mockRelinkEligibilityFalse = {
    eligible: false,
    failures: [
        {
            message: 'You have paid a downpayment for your rent.',
        },
    ],
};
exports.mockRelinkEligibilityTrue = {
    eligible: true,
    failures: [],
};
exports.ddaNameInfo = {
    first: 'Jack',
    last: 'Sparrow',
};
exports.ddaAddressInfo = {
    line_1: '123 Easytown Lane',
    city: 'Disney',
    state: 'FL',
    zip_code: '12345',
};
exports.mockDdaDetails = {
    bank_name: 'Blue Ridge Bank',
    account_number: '1234-2345-4567-4567',
    routing_number: '123-345-567',
    account_type: 'Bank account',
    account_holder_name: exports.ddaNameInfo,
    address: exports.ddaAddressInfo,
    email: 'testuser@gogogo.com',
    phone_number: '123-456-7890',
};
exports.mockBillAmount = {
    estimated_amount_cent: 105000,
    posted_amount_cent: 105100,
    posted_amount_last_updated_at: 'Oct 1 at 9:14am ET',
    can_pay_now: false,
    type: undefined,
};
exports.mockBillAmountPayNow = {
    estimated_amount_cent: 105000,
    posted_amount_cent: 105100,
    posted_amount_last_updated_at: 'Oct 1 at 9:14am ET',
    can_pay_now: true,
    type: domain_1.BillType.EPISODIC,
};
exports.mockRescheduleOptions = {
    earliest: luxon_1.DateTime.now().toFormat('yyyy-MM-dd'),
    latest: luxon_1.DateTime.now().endOf('month').toFormat('yyyy-MM-dd'),
};
exports.mockFlexAnywhereBillerId = {
    biller_id: 10010001002029,
};
exports.mockGetAccountResponse = {
    customer: {
        public_id: 'Nrd8y2lpJJOMfCFKg5xICKQHHFv1',
        identity_status: 'ACTIVE',
        referral_id: '1b9da9b6-5825-4447-bf36-e3275b231778',
        is_active: true,
        customer_type: 'NORMAL',
        first_name: 'Test',
        last_name: 'User',
        email: 'test@user.com',
        phone: '18888888888',
        address: {
            line_1: '222 W Merchandise Mart Plaza',
            line_2: null,
            city: 'Chicago',
            state: 'IL',
            zip_code: '60654',
        },
    },
    biller_connection: {
        biller_account_public_id: '61e699d1-d137-4098-b412-79ab064a1cf0',
        biller: {
            public_id: 'bv27b20349bac954bc49c6c87411b1d0dd4',
            type: 'PORTAL',
            name: 'Fortress Test Property',
            system: 'fortress',
            status: 'ACTIVE',
            document_id: 'bv27b20349bac954bc49c6c87411b1d0dd4',
        },
        status: 'ACTIVE',
        unit_number: null,
        offer_status: 'ACCEPTED',
    },
    relinking_biller_connection: null,
};
exports.mockGetAccountOnboardingResponse = __assign(__assign({}, exports.mockGetAccountResponse), { biller_connection: __assign(__assign({}, exports.mockGetAccountResponse.biller_connection), { offer_status: 'ONBOARDING' }) });
exports.mockGetAccountRelinkingResponse = __assign(__assign({}, exports.mockGetAccountResponse), { relinking_biller_connection: __assign(__assign({}, exports.mockGetAccountResponse.biller_connection), { offer_status: 'ACCEPTED' }) });
exports.mockGetBillStatusResponseDepositNotPaid = {
    bill_info: {
        header: 'Your estimated deposit of $900.00 will be collected in 5 days',
        subheader: 'We’ll finalize your payment amount and submit your rent payment automatically.',
        bill_status: {
            status: domain_1.RentPaymentStatus.ON_TRACK,
            name: 'On track',
            service_issue_code: domain_1.ServiceIssueCode.NO_ISSUE,
        },
        stage: domain_1.BillStage.GET_READY,
    },
    bill_info_shared: {
        cycle_date: '2024-06-01',
        bill_amount: 157500,
        bill_transaction_id: '12345asdfg23456sdfg',
        estimated_bill_amount: 150000,
    },
    bill_payment_config: {
        is_autopay_on: true,
        is_simplified_payment: false,
        biller_type: domain_1.BillerType.DIRECT_INTEGRATION,
        credit_line_product_type: domain_1.CreditLineProductType.SLC,
    },
};
exports.mockGetBillStatusResponseDepositFunded = {
    bill_info: {
        header: 'Thanks for funding your deposit early!',
        subheader: 'We’ll let you know if additional action is needed once we have your rent bill from your property.',
        bill_status: {
            status: domain_1.RentPaymentStatus.ON_TRACK,
            name: 'On track',
            service_issue_code: domain_1.ServiceIssueCode.NO_ISSUE,
        },
        stage: domain_1.BillStage.GET_READY,
    },
    bill_info_shared: {
        cycle_date: '2024-06-01',
        bill_amount: 157500,
        bill_transaction_id: '12345asdfg23456sdfg',
        estimated_bill_amount: 150000,
    },
    bill_payment_config: {
        is_autopay_on: true,
        is_simplified_payment: false,
        biller_type: domain_1.BillerType.DIRECT_INTEGRATION,
        credit_line_product_type: domain_1.CreditLineProductType.SLC,
    },
};
exports.mockGetBillStatusResponseDepositNotPaidFSLC = {
    bill_info: {
        header: 'Your estimated deposit of $900.00 will be collected in 5 days',
        subheader: 'We’ll finalize your payment amount and submit your rent payment automatically.',
        bill_status: {
            status: domain_1.RentPaymentStatus.ON_TRACK,
            name: 'On track',
            service_issue_code: domain_1.ServiceIssueCode.NO_ISSUE,
        },
        stage: domain_1.BillStage.GET_READY,
    },
    bill_info_shared: {
        cycle_date: '2024-06-01',
        bill_amount: 157500,
        bill_transaction_id: '12345asdfg23456sdfg',
        estimated_bill_amount: 150000,
    },
    bill_payment_config: {
        is_autopay_on: true,
        is_simplified_payment: false,
        biller_type: domain_1.BillerType.DIRECT_INTEGRATION,
        credit_line_product_type: domain_1.CreditLineProductType.FSLC,
    },
};
exports.mockGetBillStatusResponsePayingRent = {
    bill_info: {
        header: 'We’re sending your rent payment',
        subheader: 'We’re paying your total rent bill of $1,500 directly to your property.',
        bill_status: {
            status: domain_1.RentPaymentStatus.PROCESSING,
            name: 'Processing',
            service_issue_code: domain_1.ServiceIssueCode.NO_ISSUE,
        },
        stage: domain_1.BillStage.RENT_PAYMENT,
    },
    bill_info_shared: {
        cycle_date: '2024-06-01',
        bill_amount: 157500,
        bill_transaction_id: '12345asdfg23456sdfg',
        estimated_bill_amount: 150000,
    },
    bill_payment_config: {
        is_autopay_on: true,
        is_simplified_payment: false,
        biller_type: domain_1.BillerType.DIRECT_INTEGRATION,
        credit_line_product_type: domain_1.CreditLineProductType.FSLC,
    },
};
exports.mockGetBillStatusResponseRentPaidUpcomingPayment = {
    bill_info: {
        header: 'Your rent has been paid!',
        subheader: 'We’ll report your on-time rent payment to the credit bureaus.',
        bill_status: {
            status: domain_1.RentPaymentStatus.RENT_PAID,
            name: 'Rent paid',
            service_issue_code: domain_1.ServiceIssueCode.NO_ISSUE,
        },
        bill_action: {
            status: domain_1.BillActionStatus.PAY_EARLY,
            name: 'Pay early',
        },
        stage: domain_1.BillStage.SECOND_PAYMENT,
    },
    bill_info_shared: {
        cycle_date: '2024-06-01',
        bill_amount: 157500,
        bill_transaction_id: '12345asdfg23456sdfg',
        estimated_bill_amount: 150000,
    },
    bill_payment_config: {
        is_autopay_on: true,
        is_simplified_payment: false,
        biller_type: domain_1.BillerType.DIRECT_INTEGRATION,
        credit_line_product_type: domain_1.CreditLineProductType.SLC,
    },
};
exports.mockGetPaymentStatus = [
    {
        id: '1',
        bp_month: exports.firstOfMonth,
        bill_transaction_id: 'bt1',
        category: domain_1.PaymentCategoryV2.DEPOSIT,
        status: domain_1.PaymentStatusV2.SCHEDULED,
        due_date: exports.firstOfMonth,
        next_charge_date: exports.firstOfMonth,
        completion_date: exports.firstOfNextMonth,
        total_amount_cents: 100000,
        card_charge_amount: 100000,
        display_status: domain_1.DisplayStatus.SCHEDULED,
        display_title: 'Deposit',
        line_items: [
            {
                line_item_type: domain_1.LineItemType.BASE,
                amount_cents: 100000,
                display_title: 'Base Payment',
            },
        ],
        transactions: [],
    },
    {
        id: '2',
        bp_month: exports.firstOfMonth,
        bill_transaction_id: 'bt2',
        category: domain_1.PaymentCategoryV2.REPAYMENT,
        status: domain_1.PaymentStatusV2.SCHEDULED,
        due_date: exports.fifteenthOfMonth,
        completion_date: exports.firstOfNextMonth,
        total_amount_cents: 50000,
        card_charge_amount: 50000,
        display_status: domain_1.DisplayStatus.SCHEDULED,
        display_title: 'Payment',
        line_items: [
            {
                line_item_type: domain_1.LineItemType.BASE,
                amount_cents: 51500,
                display_title: 'Base Payment',
            },
            {
                line_item_type: domain_1.LineItemType.FINANCE_CHARGE,
                amount_cents: 1500,
                display_title: '2% monthly charge',
                processing_fee_percent: 2,
            },
        ],
        transactions: [],
    },
    {
        id: '3',
        bp_month: exports.firstOfMonth,
        bill_transaction_id: 'bt3',
        category: domain_1.PaymentCategoryV2.MMF,
        status: domain_1.PaymentStatusV2.SCHEDULED,
        due_date: exports.fifteenthOfMonth,
        completion_date: exports.firstOfNextMonth,
        total_amount_cents: 1500,
        card_charge_amount: 1500,
        display_status: domain_1.DisplayStatus.SCHEDULED,
        display_title: 'Membership Fee',
        line_items: [
            {
                line_item_type: domain_1.LineItemType.BASE,
                amount_cents: 1500,
                display_title: 'Base Payment',
            },
        ],
        transactions: [],
    },
];
exports.mockGetPaymentStatusScheduled = [
    {
        id: '1',
        bp_month: exports.firstOfMonth,
        bill_transaction_id: 'bt1',
        category: domain_1.PaymentCategoryV2.DOWN_PAYMENT,
        status: domain_1.PaymentStatusV2.SCHEDULED,
        due_date: exports.firstOfMonth,
        next_charge_date: exports.firstOfMonth,
        completion_date: exports.firstOfNextMonth,
        total_amount_cents: 100000,
        card_charge_amount: 100000,
        display_status: domain_1.DisplayStatus.SCHEDULED,
        available_actions: [domain_1.PaymentAvailableAction.PRE_PAY, domain_1.PaymentAvailableAction.RESCHEDULE],
        display_title: '1st Payment',
        line_items: [
            {
                line_item_type: domain_1.LineItemType.BASE,
                amount_cents: 100000,
                display_title: 'Base Payment',
            },
            {
                line_item_type: domain_1.LineItemType.PROCESSING_FEE,
                amount_cents: 1000,
                display_title: 'Bill Payment Fee (1%)',
                processing_fee_percent: 1,
            },
        ],
        transactions: [],
    },
    {
        id: '2',
        bp_month: exports.firstOfMonth,
        bill_transaction_id: 'bt2',
        category: domain_1.PaymentCategoryV2.REPAYMENT,
        status: domain_1.PaymentStatusV2.SCHEDULED,
        due_date: exports.fifteenthOfMonth,
        completion_date: exports.firstOfNextMonth,
        total_amount_cents: 50000,
        card_charge_amount: 50000,
        display_status: domain_1.DisplayStatus.SCHEDULED,
        display_title: 'Payment',
        line_items: [
            {
                line_item_type: domain_1.LineItemType.BASE,
                amount_cents: 51500,
                display_title: 'Base Payment',
            },
            {
                line_item_type: domain_1.LineItemType.FINANCE_CHARGE,
                amount_cents: 500,
                display_title: '2% monthly charge',
                processing_fee_percent: 2,
            },
        ],
        transactions: [],
    },
    {
        id: '3',
        bp_month: exports.firstOfMonth,
        bill_transaction_id: 'bt3',
        category: domain_1.PaymentCategoryV2.MMF,
        status: domain_1.PaymentStatusV2.SCHEDULED,
        due_date: exports.fifteenthOfMonth,
        completion_date: exports.firstOfNextMonth,
        total_amount_cents: 1500,
        card_charge_amount: 1500,
        display_status: domain_1.DisplayStatus.SCHEDULED,
        display_title: 'Membership Fee',
        line_items: [
            {
                line_item_type: domain_1.LineItemType.BASE,
                amount_cents: 1500,
                display_title: 'Base Payment',
            },
        ],
        transactions: [],
    },
];
exports.mockGetPaymentStatusReschedule = [
    {
        id: '1',
        user_payment_public_id: '10001-10001-10001-10000',
        bp_month: exports.firstOfMonth,
        bill_transaction_id: 'bt1',
        category: domain_1.PaymentCategoryV2.DOWN_PAYMENT,
        status: domain_1.PaymentStatusV2.SCHEDULED,
        due_date: exports.firstOfMonth,
        next_charge_date: exports.firstOfMonth,
        completion_date: exports.firstOfNextMonth,
        total_amount_cents: 100000,
        card_charge_amount: 100000,
        display_status: domain_1.DisplayStatus.SCHEDULED,
        available_actions: [domain_1.PaymentAvailableAction.PAY_NOW, domain_1.PaymentAvailableAction.RESCHEDULE],
        display_title: '1st Payment',
        line_items: [
            {
                line_item_type: domain_1.LineItemType.BASE,
                amount_cents: 100000,
                display_title: 'Base Payment',
            },
            {
                line_item_type: domain_1.LineItemType.PROCESSING_FEE,
                amount_cents: 1000,
                display_title: 'Bill Payment Fee (1%)',
                processing_fee_percent: 1,
            },
        ],
        transactions: [],
    },
    {
        id: '2',
        user_payment_public_id: '10001-10001-10001-10000',
        bp_month: exports.firstOfMonth,
        bill_transaction_id: 'bt2',
        category: domain_1.PaymentCategoryV2.REPAYMENT,
        status: domain_1.PaymentStatusV2.SCHEDULED,
        due_date: exports.fifteenthOfMonth,
        completion_date: exports.firstOfNextMonth,
        total_amount_cents: 50000,
        card_charge_amount: 50000,
        display_status: domain_1.DisplayStatus.SCHEDULED,
        available_actions: [domain_1.PaymentAvailableAction.PAY_NOW, domain_1.PaymentAvailableAction.RESCHEDULE],
        display_title: 'Payment',
        line_items: [
            {
                line_item_type: domain_1.LineItemType.BASE,
                amount_cents: 51500,
                display_title: 'Base Payment',
            },
            {
                line_item_type: domain_1.LineItemType.FINANCE_CHARGE,
                amount_cents: 500,
                display_title: '2% monthly charge',
                processing_fee_percent: 2,
            },
        ],
        transactions: [],
    },
];
exports.mockGetPaymentStatusScheduledNoPrePay = [
    {
        id: '1',
        bp_month: exports.firstOfMonth,
        bill_transaction_id: 'bt1',
        category: domain_1.PaymentCategoryV2.DOWN_PAYMENT,
        status: domain_1.PaymentStatusV2.SCHEDULED,
        due_date: exports.firstOfMonth,
        next_charge_date: exports.firstOfMonth,
        completion_date: exports.firstOfNextMonth,
        total_amount_cents: 101000,
        card_charge_amount: 101000,
        display_status: domain_1.DisplayStatus.SCHEDULED,
        available_actions: [domain_1.PaymentAvailableAction.RESCHEDULE],
        display_title: '1st Payment',
        line_items: [
            {
                line_item_type: domain_1.LineItemType.BASE,
                amount_cents: 100000,
                display_title: 'Base Payment',
            },
            {
                line_item_type: domain_1.LineItemType.PROCESSING_FEE,
                amount_cents: 1000,
                display_title: 'Bill Payment Fee (1%)',
                processing_fee_percent: 1,
            },
        ],
        transactions: [],
    },
    {
        id: '2',
        bp_month: exports.firstOfMonth,
        bill_transaction_id: 'bt2',
        category: domain_1.PaymentCategoryV2.REPAYMENT,
        status: domain_1.PaymentStatusV2.SCHEDULED,
        due_date: exports.fifteenthOfMonth,
        completion_date: exports.firstOfNextMonth,
        total_amount_cents: 50000,
        card_charge_amount: 50000,
        display_status: domain_1.DisplayStatus.SCHEDULED,
        display_title: 'Payment',
        line_items: [
            {
                line_item_type: domain_1.LineItemType.BASE,
                amount_cents: 51500,
                display_title: 'Base Payment',
            },
            {
                line_item_type: domain_1.LineItemType.FINANCE_CHARGE,
                amount_cents: 500,
                display_title: '2% monthly charge',
                processing_fee_percent: 2,
            },
        ],
        transactions: [],
    },
    {
        id: '3',
        bp_month: exports.firstOfMonth,
        bill_transaction_id: 'bt3',
        category: domain_1.PaymentCategoryV2.MMF,
        status: domain_1.PaymentStatusV2.SCHEDULED,
        due_date: exports.fifteenthOfMonth,
        completion_date: exports.firstOfNextMonth,
        total_amount_cents: 1500,
        card_charge_amount: 1500,
        display_status: domain_1.DisplayStatus.SCHEDULED,
        display_title: 'Membership Fee',
        line_items: [
            {
                line_item_type: domain_1.LineItemType.BASE,
                amount_cents: 1500,
                display_title: 'Base Payment',
            },
        ],
        transactions: [],
    },
];
exports.mockGetPaymentStatusDepositPaid = [
    {
        id: '1',
        bp_month: exports.firstOfMonth,
        bill_transaction_id: 'bt1',
        category: domain_1.PaymentCategoryV2.DEPOSIT,
        status: domain_1.PaymentStatusV2.COMPLETE,
        due_date: exports.firstOfMonth,
        next_charge_date: exports.firstOfMonth,
        completion_date: exports.firstOfMonth,
        total_amount_cents: 100000,
        card_charge_amount: 100000,
        display_status: domain_1.DisplayStatus.COMPLETE,
        display_title: 'Deposit',
        line_items: [
            {
                line_item_type: domain_1.LineItemType.BASE,
                amount_cents: 100000,
                display_title: 'Base Payment',
            },
        ],
        transactions: [],
    },
    {
        id: '2',
        bp_month: exports.firstOfMonth,
        bill_transaction_id: 'bt2',
        category: domain_1.PaymentCategoryV2.REPAYMENT,
        status: domain_1.PaymentStatusV2.SCHEDULED,
        due_date: exports.fifteenthOfMonth,
        completion_date: exports.firstOfNextMonth,
        total_amount_cents: 50000,
        card_charge_amount: 50000,
        available_actions: [domain_1.PaymentAvailableAction.PAY_NOW, domain_1.PaymentAvailableAction.RESCHEDULE],
        display_status: domain_1.DisplayStatus.SCHEDULED,
        display_title: 'Payment',
        line_items: [
            {
                line_item_type: domain_1.LineItemType.BASE,
                amount_cents: 51500,
                display_title: 'Base Payment',
            },
            {
                line_item_type: domain_1.LineItemType.FINANCE_CHARGE,
                amount_cents: 1500,
                display_title: '2% monthly charge',
                processing_fee_percent: 2,
            },
        ],
        transactions: [],
    },
];
exports.mockGetPaymentStatusFirstPaymentFunded = [
    {
        id: '1',
        bp_month: exports.firstOfMonth,
        bill_transaction_id: 'bt1',
        category: domain_1.PaymentCategoryV2.DOWN_PAYMENT,
        status: domain_1.PaymentStatusV2.COMPLETE,
        due_date: exports.firstOfMonth,
        next_charge_date: exports.firstOfMonth,
        completion_date: exports.firstOfMonth,
        total_amount_cents: 100000,
        card_charge_amount: 100000,
        display_status: domain_1.DisplayStatus.FUNDED,
        display_title: '1st Payment',
        line_items: [
            {
                line_item_type: domain_1.LineItemType.BASE,
                amount_cents: 100000,
                display_title: 'Base Payment',
            },
        ],
        transactions: [],
    },
    {
        id: '2',
        bp_month: exports.firstOfMonth,
        bill_transaction_id: 'bt2',
        category: domain_1.PaymentCategoryV2.REPAYMENT,
        status: domain_1.PaymentStatusV2.SCHEDULED,
        due_date: exports.fifteenthOfMonth,
        completion_date: exports.firstOfNextMonth,
        total_amount_cents: 50000,
        card_charge_amount: 50000,
        available_actions: [domain_1.PaymentAvailableAction.PAY_NOW, domain_1.PaymentAvailableAction.RESCHEDULE],
        display_status: domain_1.DisplayStatus.SCHEDULED,
        display_title: 'Payment',
        line_items: [
            {
                line_item_type: domain_1.LineItemType.BASE,
                amount_cents: 51500,
                display_title: 'Base Payment',
            },
            {
                line_item_type: domain_1.LineItemType.FINANCE_CHARGE,
                amount_cents: 1500,
                display_title: '2% monthly charge',
                processing_fee_percent: 2,
            },
        ],
        transactions: [
            {
                display_title: 'Payment to Flex',
                id: '1',
                transaction_type: domain_1.TransactionTypeV2.PAYMENT,
                transaction_status: domain_1.TransactionStatusV2.SUCCESS,
                transaction_date: '2024-12-01',
                display_subtext: 'Dec 1',
                completion_date: '2024-12-01',
                amount_cents: 100000,
                failure_reason: undefined,
                payment_method_id: '123456',
                payment_method_type: domain_1.PaymentMethodTypeV2.CARD,
            },
        ],
    },
];
exports.mockGetPaymentStatusFirstPaymentPaid = [
    {
        id: '1',
        bp_month: exports.firstOfMonth,
        bill_transaction_id: 'bt1',
        category: domain_1.PaymentCategoryV2.DOWN_PAYMENT,
        status: domain_1.PaymentStatusV2.COMPLETE,
        due_date: exports.firstOfMonth,
        next_charge_date: exports.firstOfMonth,
        completion_date: exports.firstOfMonth,
        total_amount_cents: 101000,
        card_charge_amount: 101000,
        display_status: domain_1.DisplayStatus.COMPLETE,
        display_title: '1st Payment',
        line_items: [
            {
                line_item_type: domain_1.LineItemType.BASE,
                amount_cents: 100000,
                display_title: 'Base Payment',
            },
            {
                line_item_type: domain_1.LineItemType.PROCESSING_FEE,
                amount_cents: 1000,
                display_title: 'Bill Payment fee (1%)',
                processing_fee_percent: 1,
            },
        ],
        transactions: [
            {
                display_title: 'Payment to Flex',
                id: '1',
                transaction_type: domain_1.TransactionTypeV2.PAYMENT,
                transaction_status: domain_1.TransactionStatusV2.SUCCESS,
                transaction_date: '2024-12-01',
                display_subtext: 'Dec 1',
                completion_date: '2024-12-01',
                amount_cents: 91000,
                failure_reason: undefined,
                payment_method_id: '123456',
                payment_method_type: domain_1.PaymentMethodTypeV2.CARD,
            },
            {
                display_title: 'Flex funds',
                id: '2',
                transaction_type: domain_1.TransactionTypeV2.PAYMENT,
                transaction_status: domain_1.TransactionStatusV2.SUCCESS,
                transaction_date: '2024-12-01',
                display_subtext: 'Dec 1',
                completion_date: '2024-12-01',
                amount_cents: 10000,
                failure_reason: undefined,
                payment_method_id: '010101',
                payment_method_type: domain_1.PaymentMethodTypeV2.FUNDS,
            },
        ],
    },
    {
        id: '2',
        bp_month: exports.firstOfMonth,
        bill_transaction_id: 'bt2',
        category: domain_1.PaymentCategoryV2.REPAYMENT,
        status: domain_1.PaymentStatusV2.SCHEDULED,
        due_date: exports.fifteenthOfMonth,
        completion_date: exports.firstOfNextMonth,
        total_amount_cents: 50000,
        card_charge_amount: 50000,
        available_actions: [domain_1.PaymentAvailableAction.PAY_NOW, domain_1.PaymentAvailableAction.RESCHEDULE],
        display_status: domain_1.DisplayStatus.SCHEDULED,
        display_title: 'Payment',
        line_items: [
            {
                line_item_type: domain_1.LineItemType.BASE,
                amount_cents: 51500,
                display_title: 'Base Payment',
            },
            {
                line_item_type: domain_1.LineItemType.FINANCE_CHARGE,
                amount_cents: 1500,
                display_title: '2% monthly charge',
                processing_fee_percent: 2,
            },
        ],
        transactions: [],
    },
];
exports.mockGetPaymentStatusCovered = [
    {
        id: '1',
        bp_month: exports.firstOfMonth,
        bill_transaction_id: 'bt1',
        category: domain_1.PaymentCategoryV2.DEPOSIT,
        status: domain_1.PaymentStatusV2.COMPLETE,
        due_date: exports.firstOfMonth,
        next_charge_date: exports.firstOfMonth,
        completion_date: exports.firstOfMonth,
        total_amount_cents: 100000,
        card_charge_amount: 100000,
        display_status: domain_1.DisplayStatus.COMPLETE,
        display_title: 'Deposit',
        line_items: [
            {
                line_item_type: domain_1.LineItemType.BASE,
                amount_cents: 100000,
                display_title: 'Base Payment',
            },
        ],
        transactions: [],
    },
    {
        id: '2',
        bp_month: exports.firstOfMonth,
        bill_transaction_id: 'bt2',
        category: domain_1.PaymentCategoryV2.REPAYMENT,
        status: domain_1.PaymentStatusV2.COMPLETE,
        due_date: exports.fifteenthOfMonth,
        completion_date: exports.firstOfNextMonth,
        total_amount_cents: 50000,
        card_charge_amount: 50000,
        display_status: domain_1.DisplayStatus.COMPLETE,
        display_title: 'Payment',
        line_items: [
            {
                line_item_type: domain_1.LineItemType.BASE,
                amount_cents: 51500,
                display_title: 'Base Payment',
            },
            {
                line_item_type: domain_1.LineItemType.FINANCE_CHARGE,
                amount_cents: 1500,
                display_title: '2% monthly charge',
                processing_fee_percent: 2,
            },
        ],
        transactions: [],
    },
];
exports.mockGetPaymentStatusNotCovered = [
    {
        id: '1',
        bp_month: exports.firstOfMonth,
        bill_transaction_id: 'bt1',
        category: domain_1.PaymentCategoryV2.DEPOSIT,
        status: domain_1.PaymentStatusV2.COMPLETE,
        due_date: exports.firstOfMonth,
        next_charge_date: exports.firstOfMonth,
        completion_date: exports.firstOfMonth,
        total_amount_cents: 100000,
        card_charge_amount: 100000,
        display_status: domain_1.DisplayStatus.UNPAID,
        display_title: '1st Payment',
        line_items: [
            {
                line_item_type: domain_1.LineItemType.BASE,
                amount_cents: 100000,
                display_title: 'Base Payment',
            },
        ],
        transactions: [],
    },
    {
        id: '2',
        bp_month: exports.firstOfMonth,
        bill_transaction_id: 'bt2',
        category: domain_1.PaymentCategoryV2.REPAYMENT,
        status: domain_1.PaymentStatusV2.COMPLETE,
        due_date: exports.fifteenthOfMonth,
        completion_date: exports.firstOfNextMonth,
        total_amount_cents: 50000,
        card_charge_amount: 50000,
        display_status: domain_1.DisplayStatus.UNPAID,
        display_title: 'Payment',
        line_items: [
            {
                line_item_type: domain_1.LineItemType.BASE,
                amount_cents: 51500,
                display_title: 'Base Payment',
            },
            {
                line_item_type: domain_1.LineItemType.FINANCE_CHARGE,
                amount_cents: 1500,
                display_title: '2% monthly charge',
                processing_fee_percent: 2,
            },
        ],
        transactions: [],
    },
];
exports.mockGetPaymentStatusSecondPaymentFailed = [
    {
        id: '1',
        bp_month: exports.firstOfMonth,
        bill_transaction_id: 'bt1',
        category: domain_1.PaymentCategoryV2.DOWN_PAYMENT,
        status: domain_1.PaymentStatusV2.COMPLETE,
        due_date: exports.firstOfMonth,
        next_charge_date: exports.firstOfMonth,
        completion_date: exports.firstOfMonth,
        total_amount_cents: 100000,
        card_charge_amount: 100000,
        display_status: domain_1.DisplayStatus.COMPLETE,
        display_title: '1st Payment',
        line_items: [
            {
                line_item_type: domain_1.LineItemType.BASE,
                amount_cents: 100000,
                display_title: 'Base Payment',
            },
        ],
        transactions: [
            {
                display_title: 'Payment to Flex',
                id: '1',
                transaction_type: domain_1.TransactionTypeV2.PAYMENT,
                transaction_status: domain_1.TransactionStatusV2.SUCCESS,
                transaction_date: '2024-12-01',
                display_subtext: 'Dec 1',
                completion_date: '2024-12-01',
                amount_cents: 91000,
                failure_reason: undefined,
                payment_method_id: '123456',
                payment_method_type: domain_1.PaymentMethodTypeV2.CARD,
            },
        ],
    },
    {
        id: '2',
        bp_month: exports.firstOfMonth,
        bill_transaction_id: 'bt2',
        category: domain_1.PaymentCategoryV2.REPAYMENT,
        status: domain_1.PaymentStatusV2.ACTION_NEEDED,
        due_date: exports.fifteenthOfMonth,
        completion_date: exports.firstOfNextMonth,
        total_amount_cents: 50000,
        card_charge_amount: 50000,
        display_status: domain_1.DisplayStatus.FAILURE,
        display_title: '2nd Payment',
        available_actions: [domain_1.PaymentAvailableAction.RESCHEDULE, domain_1.PaymentAvailableAction.PAY_NOW],
        line_items: [
            {
                line_item_type: domain_1.LineItemType.BASE,
                amount_cents: 51500,
                display_title: 'Base Payment',
            },
            {
                line_item_type: domain_1.LineItemType.PROCESSING_FEE,
                amount_cents: 1500,
                display_title: 'Bill payment fee',
                processing_fee_percent: 1,
            },
        ],
        transactions: [
            {
                display_title: 'Payment to Flex',
                id: '1',
                transaction_type: domain_1.TransactionTypeV2.PAYMENT,
                transaction_status: domain_1.TransactionStatusV2.FAILURE,
                transaction_date: '2024-12-01',
                display_subtext: 'Dec 1',
                completion_date: '2024-12-01',
                amount_cents: 51500,
                failure_reason: undefined,
                payment_method_id: '123456',
                payment_method_type: domain_1.PaymentMethodTypeV2.CARD,
            },
        ],
    },
];
exports.mockGetPaymentStatusInsufficientFunds = [
    {
        id: '1',
        bp_month: exports.firstOfMonth,
        bill_transaction_id: 'bt1',
        category: domain_1.PaymentCategoryV2.DOWN_PAYMENT,
        status: domain_1.PaymentStatusV2.ACTION_NEEDED,
        due_date: exports.firstOfMonth,
        next_charge_date: exports.firstOfMonth,
        completion_date: exports.firstOfMonth,
        total_amount_cents: 100000,
        card_charge_amount: 100000,
        display_status: domain_1.DisplayStatus.FAILURE,
        display_title: '1st Payment',
        available_actions: [domain_1.PaymentAvailableAction.PAY_NOW],
        line_items: [
            {
                line_item_type: domain_1.LineItemType.BASE,
                amount_cents: 100000,
                display_title: 'Base Payment',
            },
        ],
        transactions: [
            {
                display_title: 'Payment to Flex',
                id: '1',
                transaction_type: domain_1.TransactionTypeV2.PAYMENT,
                transaction_status: domain_1.TransactionStatusV2.FAILURE,
                transaction_date: '2024-12-01',
                display_subtext: 'Dec 1',
                completion_date: '2024-12-01',
                amount_cents: 91000,
                failure_reason: undefined,
                payment_method_id: '123456',
                payment_method_type: domain_1.PaymentMethodTypeV2.CARD,
            },
        ],
    },
    {
        id: '2',
        bp_month: exports.firstOfMonth,
        bill_transaction_id: 'bt2',
        category: domain_1.PaymentCategoryV2.REPAYMENT,
        status: domain_1.PaymentStatusV2.SCHEDULED,
        due_date: exports.fifteenthOfMonth,
        completion_date: exports.firstOfNextMonth,
        total_amount_cents: 50000,
        card_charge_amount: 50000,
        display_status: domain_1.DisplayStatus.SCHEDULED,
        display_title: '2nd Payment',
        available_actions: [],
        line_items: [
            {
                line_item_type: domain_1.LineItemType.BASE,
                amount_cents: 51500,
                display_title: 'Base Payment',
            },
            {
                line_item_type: domain_1.LineItemType.PROCESSING_FEE,
                amount_cents: 1500,
                display_title: 'Bill payment fee',
                processing_fee_percent: 1,
            },
        ],
        transactions: [],
    },
];
exports.mockGetPaymentStatusSecondPayment = [
    {
        id: '1',
        bp_month: exports.firstOfMonth,
        bill_transaction_id: 'bt1',
        category: domain_1.PaymentCategoryV2.DOWN_PAYMENT,
        status: domain_1.PaymentStatusV2.COMPLETE,
        due_date: exports.firstOfMonth,
        next_charge_date: exports.firstOfMonth,
        completion_date: exports.firstOfMonth,
        total_amount_cents: 100000,
        card_charge_amount: 100000,
        display_status: domain_1.DisplayStatus.COMPLETE,
        display_title: '1st Payment',
        line_items: [
            {
                line_item_type: domain_1.LineItemType.BASE,
                amount_cents: 100000,
                display_title: 'Base Payment',
            },
        ],
        transactions: [],
    },
    {
        id: '2',
        bp_month: exports.firstOfMonth,
        bill_transaction_id: 'bt2',
        category: domain_1.PaymentCategoryV2.REPAYMENT,
        status: domain_1.PaymentStatusV2.SCHEDULED,
        due_date: exports.fifteenthOfMonth,
        completion_date: exports.firstOfNextMonth,
        total_amount_cents: 50000,
        card_charge_amount: 50000,
        display_status: domain_1.DisplayStatus.SCHEDULED,
        display_title: '2nd Payment',
        available_actions: [domain_1.PaymentAvailableAction.PAY_NOW, domain_1.PaymentAvailableAction.RESCHEDULE],
        line_items: [
            {
                line_item_type: domain_1.LineItemType.BASE,
                amount_cents: 51500,
                display_title: 'Base Payment',
            },
            {
                line_item_type: domain_1.LineItemType.PROCESSING_FEE,
                amount_cents: 1500,
                display_title: 'Bill payment fee',
                processing_fee_percent: 1,
            },
        ],
        transactions: [],
    },
];
exports.mockGetPaymentStatusCreditBuilder = [
    {
        id: '1',
        bp_month: exports.firstOfMonth,
        bill_transaction_id: 'bt1',
        category: domain_1.PaymentCategoryV2.DEPOSIT,
        status: domain_1.PaymentStatusV2.SCHEDULED,
        due_date: exports.firstOfMonth,
        next_charge_date: exports.firstOfMonth,
        completion_date: exports.firstOfNextMonth,
        total_amount_cents: 125000,
        card_charge_amount: 125000,
        available_actions: [domain_1.PaymentAvailableAction.PAY_NOW],
        display_status: domain_1.DisplayStatus.SCHEDULED,
        display_title: '',
        line_items: [
            {
                line_item_type: domain_1.LineItemType.BASE,
                amount_cents: 125000,
                display_title: 'Base Payment',
            },
        ],
        transactions: [],
    },
    {
        id: '2',
        bp_month: exports.fifteenthOfMonth,
        bill_transaction_id: 'bt2',
        category: domain_1.PaymentCategoryV2.MMF,
        status: domain_1.PaymentStatusV2.SCHEDULED,
        due_date: exports.fifteenthOfMonth,
        completion_date: exports.firstOfNextMonth,
        total_amount_cents: 1125,
        card_charge_amount: 1125,
        display_status: domain_1.DisplayStatus.SCHEDULED,
        display_title: '21st of the month',
        line_items: [
            {
                line_item_type: domain_1.LineItemType.FINANCE_CHARGE,
                amount_cents: 3750,
                display_title: '0.75% monthly rate',
                processing_fee_percent: 0.75,
            },
        ],
        transactions: [],
    },
];
exports.mockGetPaymentStatusCreditBuilderMonthTwo = [
    {
        id: '1',
        bp_month: exports.firstOfMonth,
        bill_transaction_id: 'bt1',
        category: domain_1.PaymentCategoryV2.REPAYMENT,
        status: domain_1.PaymentStatusV2.SCHEDULED,
        due_date: exports.firstOfMonth,
        next_charge_date: exports.firstOfMonth,
        completion_date: exports.firstOfNextMonth,
        total_amount_cents: 125000,
        card_charge_amount: 125000,
        available_actions: [domain_1.PaymentAvailableAction.RESCHEDULE],
        display_status: domain_1.DisplayStatus.SCHEDULED,
        display_title: '',
        line_items: [
            {
                line_item_type: domain_1.LineItemType.BASE,
                amount_cents: 125000,
                display_title: 'Payment subtotal',
            },
        ],
        transactions: [],
    },
    {
        id: '2',
        bp_month: exports.fifteenthOfMonth,
        bill_transaction_id: 'bt2',
        category: domain_1.PaymentCategoryV2.MMF,
        status: domain_1.PaymentStatusV2.SCHEDULED,
        due_date: exports.fifteenthOfMonth,
        completion_date: exports.firstOfNextMonth,
        total_amount_cents: 1125,
        card_charge_amount: 1125,
        display_status: domain_1.DisplayStatus.SCHEDULED,
        display_title: '21st of the month',
        line_items: [
            {
                line_item_type: domain_1.LineItemType.FINANCE_CHARGE,
                amount_cents: 3750,
                display_title: '0.75% monthly rate',
                processing_fee_percent: 0.75,
            },
        ],
        transactions: [],
    },
];
exports.mockGetPaymentStatusCreditBuilderMonthTwoRepaymentFailed = [
    {
        id: '1',
        bp_month: exports.firstOfMonth,
        bill_transaction_id: 'bt1',
        category: domain_1.PaymentCategoryV2.REPAYMENT,
        status: domain_1.PaymentStatusV2.ACTION_NEEDED,
        due_date: exports.firstOfMonth,
        next_charge_date: exports.firstOfMonth,
        completion_date: exports.firstOfNextMonth,
        total_amount_cents: 125000,
        card_charge_amount: 125000,
        available_actions: [domain_1.PaymentAvailableAction.RESCHEDULE],
        display_status: domain_1.DisplayStatus.FAILURE,
        display_title: '',
        line_items: [
            {
                line_item_type: domain_1.LineItemType.BASE,
                amount_cents: 125000,
                display_title: 'Payment subtotal',
            },
        ],
        transactions: [],
    },
    {
        id: '2',
        bp_month: exports.fifteenthOfMonth,
        bill_transaction_id: 'bt2',
        category: domain_1.PaymentCategoryV2.MMF,
        status: domain_1.PaymentStatusV2.SCHEDULED,
        due_date: exports.fifteenthOfMonth,
        completion_date: exports.firstOfNextMonth,
        total_amount_cents: 1125,
        card_charge_amount: 1125,
        display_status: domain_1.DisplayStatus.SCHEDULED,
        display_title: '21st of the month',
        line_items: [
            {
                line_item_type: domain_1.LineItemType.FINANCE_CHARGE,
                amount_cents: 3750,
                display_title: '0.75% monthly rate',
                processing_fee_percent: 0.75,
            },
        ],
        transactions: [],
    },
];
exports.mockGetBillStatusResponseFullyPaid = {
    bill_info: {
        header: 'Your rent has been paid!',
        subheader: 'We’ll report your on-time rent payment to the credit bureaus.',
        bill_status: {
            status: domain_1.RentPaymentStatus.RENT_PAID,
            name: 'Rent paid',
            service_issue_code: domain_1.ServiceIssueCode.NO_ISSUE,
        },
        stage: domain_1.BillStage.SECOND_PAYMENT,
    },
    bill_info_shared: {
        cycle_date: '2024-06-01',
        bill_amount: 157500,
        bill_transaction_id: '12345asdfg23456sdfg',
        estimated_bill_amount: 150000,
    },
    bill_payment_config: {
        is_autopay_on: true,
        is_simplified_payment: false,
        biller_type: domain_1.BillerType.DIRECT_INTEGRATION,
        credit_line_product_type: domain_1.CreditLineProductType.SLC,
    },
};
exports.mockGetBillStatusCreditBuilderResponseFullyPaid = {
    bill_info: {
        header: 'Your rent has been paid!',
        subheader: 'We’ll report your on-time rent payment to the credit bureaus.',
        bill_status: {
            status: domain_1.RentPaymentStatus.RENT_PAID,
            name: 'Rent paid',
            service_issue_code: domain_1.ServiceIssueCode.NO_ISSUE,
        },
        stage: domain_1.BillStage.SECOND_PAYMENT,
    },
    bill_info_shared: {
        cycle_date: '2024-10-01',
        bill_amount: 125000,
        bill_transaction_id: '12345asdfg23456sdfg',
        estimated_bill_amount: 125000,
    },
    bill_payment_config: {
        is_autopay_on: true,
        is_simplified_payment: false,
        biller_type: domain_1.BillerType.DIRECT_INTEGRATION,
        credit_line_product_type: domain_1.CreditLineProductType.SLC,
    },
};
exports.mockGetBillStatusResponseRelink = {
    bill_info: {
        header: 'We couldn’t find your rent bill',
        subheader: 'Re-link your property to resume Flex service.',
        bill_status: {
            status: domain_1.RentPaymentStatus.SERVICE_ISSUE,
            name: 'Service issue',
            service_issue_code: domain_1.ServiceIssueCode.RELINK_PROPERTY,
        },
        bill_action: {
            status: domain_1.BillActionStatus.VIEW_DETAILS,
            name: 'View details',
        },
        stage: domain_1.BillStage.RENT_PAYMENT,
    },
    bill_info_shared: {
        cycle_date: '2024-06-01',
        bill_amount: 157500,
        bill_transaction_id: '12345asdfg23456sdfg',
        estimated_bill_amount: 150000,
    },
    bill_payment_config: {
        is_autopay_on: true,
        is_simplified_payment: false,
        biller_type: domain_1.BillerType.DIRECT_INTEGRATION,
        credit_line_product_type: domain_1.CreditLineProductType.FSLC,
    },
};
exports.mockGetBillStatusResponseEpisodicReadyToPay = {
    bill_info: {
        header: 'Ready to pay your rent?',
        subheader: 'Your bill has posted and is ready to be paid. Flex can pay your bill in full and split the cost for you.',
        bill_status: {
            status: domain_1.RentPaymentStatus.ON_TRACK,
            name: 'Ready',
            service_issue_code: domain_1.ServiceIssueCode.NO_ISSUE,
        },
        bill_action: {
            status: domain_1.BillActionStatus.PAY_RENT,
            name: 'Split your rent',
        },
        stage: domain_1.BillStage.GET_READY,
    },
    bill_info_shared: {
        cycle_date: '2024-06-01',
        bill_amount: 157500,
        bill_transaction_id: '12345asdfg23456sdfg',
        estimated_bill_amount: 150000,
    },
    bill_payment_config: {
        is_autopay_on: true,
        is_simplified_payment: false,
        biller_type: domain_1.BillerType.DIRECT_INTEGRATION,
        credit_line_product_type: domain_1.CreditLineProductType.SLC,
    },
};
exports.mockBillPayNowEmbedEligibilitySuccess = {
    bp_start_date: luxon_1.DateTime.utc().toISODate(),
    bp_end_date: exports.bpEndDate,
    eligible: true,
};
exports.mockBillPayNowEmbedEligibilityErrorBpWindow = {
    bp_start_date: exports.bpStartDate,
    bp_end_date: exports.bpEndDate,
    eligible: false,
    failure_code: domain_1.EmbedPayNowEligibilityFailureCode.BP_WINDOW,
};
exports.mockBillPayNowEmbedEligibilityErrorAutopayOn = {
    bp_start_date: exports.bpStartDate,
    bp_end_date: exports.bpEndDate,
    eligible: false,
    failure_code: domain_1.EmbedPayNowEligibilityFailureCode.AUTOPAY_ON,
};
exports.mockBillPayNowEmbedEligibilityErrorRentPaymentInProgress = {
    bp_start_date: exports.bpStartDate,
    bp_end_date: exports.bpEndDate,
    eligible: false,
    failure_code: domain_1.EmbedPayNowEligibilityFailureCode.RENT_PAYMENT_IN_PROGRESS,
};
exports.mockBillPayNowEmbedEligibilityErrorRentPaid = {
    bp_start_date: exports.bpStartDate,
    bp_end_date: exports.bpEndDate,
    eligible: false,
    failure_code: domain_1.EmbedPayNowEligibilityFailureCode.RENT_PAID,
};
exports.mockBillPayNowEmbedEligibilityErrorInvalidProduct = {
    bp_start_date: exports.bpStartDate,
    bp_end_date: exports.bpEndDate,
    eligible: false,
    failure_code: domain_1.EmbedPayNowEligibilityFailureCode.INVALID_PRODUCT,
};
exports.mockBillPayNowEmbedEligibilityErrorInvalidBalance = {
    bp_start_date: exports.bpStartDate,
    bp_end_date: exports.bpEndDate,
    eligible: false,
    failure_code: domain_1.EmbedPayNowEligibilityFailureCode.INVALID_BALANCE,
};
exports.mockBillPayNowEmbedEligibilityErrorUnknown = {
    bp_start_date: exports.bpStartDate,
    bp_end_date: exports.bpEndDate,
    eligible: false,
    failure_code: domain_1.EmbedPayNowEligibilityFailureCode.UNKNOWN,
};
exports.mockRescheduleDPOptions = {
    earliest: luxon_1.DateTime.utc().endOf('month').toFormat('yyyy-MM-dd'),
    latest: luxon_1.DateTime.now().set({ day: 1 }).plus({ month: 1, day: 5 }).toFormat('yyyy-MM-dd'),
};
exports.mockGetRentBillDetails = {
    bill: [
        { name: 'Rent', amount: '$1500.00' },
        { name: 'City fee', amount: '$10.00' },
        { name: 'Water', amount: '$48.00' },
        { name: 'Trash', amount: '$12.00' },
    ],
    posted_at: '2024-09-11T03:23:39.692Z',
};
exports.mockGetRentAmountSurveyOptions = {
    choices: [
        {
            id: 1,
            response_choice: domain_1.ResponseChoice.INCORRECT_ESTIMATE,
            response_text: 'My estimate was wrong, this is my typical rent amount',
        },
        {
            id: 2,
            response_choice: domain_1.ResponseChoice.ADDITIONAL_CHARGES,
            response_text: 'There are additional charges, but this is a one-time event',
        },
        {
            id: 3,
            response_choice: domain_1.ResponseChoice.ROOMMATE_PORTION,
            response_text: 'I have a roommate who still needs to pay their portion',
        },
        {
            id: 4,
            response_choice: domain_1.ResponseChoice.BEHIND_ON_RENT,
            response_text: 'I’m behind on my rent, so there’s an overdue amount that got carried forward',
        },
        {
            id: 5,
            response_choice: domain_1.ResponseChoice.PERMANENT_INCREASE,
            response_text: 'My rent has permanently increased',
        },
        {
            id: 6,
            response_choice: domain_1.ResponseChoice.ALREADY_PAID,
            response_text: 'I have already paid my rent',
        },
        {
            id: 7,
            response_choice: domain_1.ResponseChoice.BALANCE_TOO_LOW,
            response_text: 'My rent balance is too low to be covered',
        },
    ],
};
exports.mockGetCutoffDates = {
    cutoffs: [
        {
            type: domain_1.CutoffType.EARLY_PAY_DP_CUTOFF,
            date_time: luxon_1.DateTime.utc().toISODate(),
        },
        {
            type: domain_1.CutoffType.ADDITIONAL_DP_CUTOFF,
            date_time: luxon_1.DateTime.utc().toISODate(),
        },
    ],
};
